"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalUrlPatterns = exports.PrivacyPolicyByLanguage = exports.TermsOfUseByLanguage = void 0;
exports.TermsOfUseByLanguage = {
    fi: 'https://www.sokopro.com/kayttajaehdot/',
    en: 'https://www.sokopro.com/en/terms-of-use/',
    sv: 'https://www.sokopro.com/sv/anvandarvilkor/'
};
exports.PrivacyPolicyByLanguage = {
    fi: 'https://www.sokopro.com/tietosuojaseloste/',
    en: 'https://www.sokopro.com/en/privacy-policy-2/',
    sv: 'https://www.sokopro.com/sv/integritetspolicy/'
};
exports.externalUrlPatterns = [
    encodeURIComponent(__UPLOADSERVERURL__),
    __UPLOADSERVERURL__
];
